import { Theme } from './types';

export const defaultTheme: Theme = {
  id: 'default',
  name: '阿瓦隆经典主题',
  
  colors: {
    'bg-primary': '#1A0F2A',
    'bg-secondary': '#1F1535',
    'bg-card': 'rgba(26, 15, 42, 0.8)',
    'bg-card-hover': 'rgba(31, 21, 53, 0.9)',
    'accent-gold': '#FFD700',
    'accent-gold-hover': '#FFC700',
    'accent-purple': '#7B5BA8',
    'accent-red': '#DC2626',
    'text-primary': '#FFFFFF',
    'text-secondary': '#B8A9C9',
    'text-muted': '#6B5B8C',
    'text-gold': '#FFD700',
    'border-primary': '#7B5BA8',
    'border-secondary': '#5A4BFF',
    'border-accent': '#FFD700',
  },
  
  images: {
    'bg-home': null,
    'bg-voice-host': null,
    'bg-game-stats': null,
    'bg-game-guide': null,
    'bg-deal-cards': null,
    'bg-vote-tool': null,
    'bg-speech-timer': null,
    'bg-mission-vote': null,
    'bg-player-detail': null,
    'bg-game-progress': null,
    'card-frame': null,
    'btn-primary': null,
  },
  
  animations: {
    'transition-speed': '0.3s',
    'hover-scale': 1.02,
    'active-scale': 0.98,
    'glow-intensity': 0.5,
    'fade-duration': '0.2s',
  },
  
  typography: {
    'font-family': 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    'font-size-base': '16px',
    'line-height-base': 1.5,
  },
  
  effects: {
    'shadow-card': '0 4px 6px rgba(0, 0, 0, 0.3)',
    'shadow-glow': '0 0 20px rgba(255, 215, 0, 0.5)',
    'radius-card': '12px',
    'radius-btn': '8px',
  },
};
